import axios from 'axios';

import { setUnderMaintenance } from '../errorSlice';
import { AppDispatch } from '../../store';
import { logOut } from '../../auth/authSlice';

export const setUnderMaintenanceInterceptor = (dispatch: AppDispatch) => {
  axios.interceptors.response.use(
    response => {
      return response;
    },
    async err => {
      if (is503ErrorResponse(err)) {
        // Show under maintenance page
        dispatch(logOut());
        dispatch(setUnderMaintenance(true));
      }

      return Promise.reject(err);
    }
  );
};

const is503ErrorResponse = (error: unknown) => {
  const errorResponse = error as { response: { status: number } };
  return (
    error !== null &&
    errorResponse !== undefined &&
    errorResponse.response !== undefined &&
    errorResponse.response.status === 503
  );
};
